import { defineComponent as o } from "vue";
import { MsArrowRight as n } from "@sunrise/icons";
const s = o({
  name: "CsLinkGroup",
  components: { MsArrowRight: n },
  props: {
    hasSingleColumn: Boolean,
    hasMaxColumns: Boolean,
    hasHyphens: Boolean,
    links: {
      type: Array,
      default: () => []
    },
    amountVisibleLinks: {
      type: Number,
      default: 1 / 0
    }
  }
});
export {
  s as default
};
